import React from 'react';

import './_customers.scss'
import {Breadcrumb, BreadcrumbItem, Column, Grid, Tile} from "@carbon/react";
import {Link} from "react-router-dom";
import CustomersTable from "../../components/CustomersTable";
import PropTypes from "prop-types";

const Customers = ({runningRecording, updateRunningRecording}) => {
  return (
    <Grid fullWidth className="customers-page">
      <Column lg={16} md={8} sm={4}>
        <Grid className="page-banner">
          <Column lg={16} md={4} sm={4}>
            <Breadcrumb noTrailingSlash aria-label="Page navigation">
              <BreadcrumbItem>
                <Link to='/'>Home</Link>
              </BreadcrumbItem>
              <BreadcrumbItem>
                Sistemi
              </BreadcrumbItem>
            </Breadcrumb>
          </Column>
          <Column lg={16} md={4} sm={4}>
            <h1 className="page-heading">
              Sistemi
            </h1>
          </Column>
        </Grid>
        <Grid>
          <Column lg={16} md={8} sm={4} className="customers-page__r1">
            <Tile>
              <CustomersTable runningRecording={runningRecording} updateRunningRecording={updateRunningRecording}/>
            </Tile>
          </Column>
        </Grid>
      </Column>
    </Grid>
  )
}

Customers.propTypes = {
  runningRecording: PropTypes.object,
  updateRunningRecording: PropTypes.func.isRequired
}

export default Customers